import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { IVolunteerAttendance } from './models';
import { invalidateVolunteerRoster } from './useVolunteerRoster';

export const useCheckInVolunteerMutation = ({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (data: IVolunteerAttendance) => void;
} = {}) => {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({
			activityId,
			contactId,
			shiftId,
			roleId,
			impersonationContext,
		}: {
			activityId: string;
			contactId: string;
			shiftId?: string;
			roleId?: string;
			impersonationContext?: Api.IImpersonationContext;
		}) =>
			userSession.webServiceHelper.callAsync<IVolunteerAttendance>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `volunteering/activities/${activityId}/attendance/checkIn`,
				}),
				'POST',
				{ contactId, shiftId, roleId }
			),
		onSuccess: (data, variables) => {
			invalidateVolunteerRoster(variables.activityId);
			onSuccess?.(data);
		},
		onError,
	});
};
